import { memo } from 'react';
import cn from 'classnames';
import type { NodeToRenderProps, NodeToRenderTimeoutData } from './types/custom-nodes.type';
import { applyGenericHocs } from '../../scenario-editor/utils';
import { CustomTooltip } from '../tooltip/Tooltip';
import { Icon } from '@src/components/icon/Icon';

export const MenuItem = ({ children, className, ...props }: NodeToRenderProps) => {
  return (
  <div
    className={
      cn([
        "flex rounded-md p-2 border-2 border-transparent bg-input h-full justify-center items-center w-fit text-sm truncate",
        className,
      ])
    }
    {...props}
  >{children}</div>
)};

export const NodeItem = ({ data, ...props }: NodeToRenderProps) => {
  const { timeout } = data as NodeToRenderTimeoutData;
  return (
    <div
      className={
        cn([
          props.className,
          "flex flex-col py-2 px-2 rounded-md border-2 border-transparent bg-transparent justify-center items-center w-fit text-sm h-[94px]",
        ])
      }
      style={props.style}
    >
      <div><Icon type="timeout" variant="nodeIcon" size="large" /></div>
      <div className="text-center text-xs pt-2">Timeout</div>
      {timeout ? (
        <CustomTooltip content={timeout}>
          <p className="text-center text-sm font-bold truncate max-w-full break-all">{timeout}</p>
        </CustomTooltip>
      ) : (
        <p className="text-center text-sm text-label-foreground font-bold truncate max-w-full break-all">Add timeout</p>
      )}

    </div>
  )
};

const WrappedNodeToRender = applyGenericHocs(NodeItem);

const Timeout: React.FC<NodeToRenderProps> = (props: NodeToRenderProps) => {
  const { title } = props.data as NodeToRenderTimeoutData;
  return (
    <>
      <WrappedNodeToRender {...props}>{title}</WrappedNodeToRender>
    </>
  );
};

export const TimeoutNode = memo(Timeout);
